<template>
  <div class="home">
    <div class="userInfo">
      <div class="header">
        <div class="pHeader">
          <h3>我的项目</h3>
          <h2 @click="$router.push('/uploadMyProgram')">项目申请</h2>
        </div>
        <div class="line"></div>
      </div>
      <div class="pNav">
        <div class="pNavLeft">
          <ul>
            <li
              :class="index == currentIndex ? 'selected' : ''"
              :style="index == 0 ? 'border-left:none' : ''"
              v-for="(item, index) in nav"
              :key="item.name"
              @click="changeNav(item, index)"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="pNavRight">
          <el-input
            placeholder="请输入内容"
            suffix-icon="el-icon-search"
            @keyup.enter.native="search"
            v-model="keyword"
            size="mini"
            style="width: 1.5rem"
          ></el-input>
        </div>
      </div>
      <div v-if="paginations.total > 0">
        <div
          class="program"
          v-for="(item, index) in programData"
          :key="item.id"
        >
          <div class="pTop">
            <div
              class="pTopLeft"
              @click="$router.push(`/programDetail/${item.id}`)"
            >
              <img :src="item.picture" alt />
            </div>
            <div class="pTopRight">
              <div class="pShow">
                <p>项目名称：</p>
                <h3>{{ item.name }}</h3>
              </div>
              <div class="pShow">
                <p>项目状态：</p>
                <h1 v-if="item.status == 1">审核中</h1>
                <h1 v-else-if="item.status == 0">编辑中</h1>
                <h1 v-if="item.status == 2">募集中</h1>
                <h1 v-if="item.status == 3">运营中</h1>
                <h1 v-if="item.status == 4">已结束</h1>
                <h1 v-if="item.status == 5" style="color: red">
                  审核失败：{{ item.reject }}
                </h1>
                <h1 v-if="item.status == 6" style="color: red">前台隐藏</h1>
                <el-select
                  v-if="item.status > 1 && item.status != 5"
                  @change="selectChange($event, item)"
                  v-model="status"
                  size="mini"
                  style="width: 1.2rem"
                  clearable
                  placeholder="修改项目状态"
                >
                  <el-option
                    v-for="items in selStatus"
                    :key="items.status"
                    :label="items.name"
                    :value="items.status"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="pShow">
                <p>发起时间：</p>
                <h3>{{ item.donatime }}</h3>
              </div>
              <div class="pShow">
                <p>已募集金额（元）：</p>
                <div class="pMore">
                  <h2>{{ item.raisefund }}</h2>
                  <h4
                    @click="
                      $router.push({ name: 'jzList', params: { pid: item.id } })
                    "
                  >
                    查看捐赠人
                  </h4>
                </div>
              </div>
              <div class="pShow">
                <p>可使用金额（元）：</p>
                <div class="pMore">
                  <h2>{{ item.syMoney }}</h2>
                  <h4
                    @click="
                      $router.push({ name: 'szList', params: { pid: item.id } })
                    "
                  >
                    查看受助人
                  </h4>
                </div>
              </div>
              <div class="pShow">
                <p>更新时间：</p>
                <h3>{{ item.donadate }}</h3>
              </div>
            </div>
          </div>
          <div class="pFooter">
            <h4 @click="editProgram(item)">编辑</h4>
            <!-- <h4
              @click="handleDelete(index, item)"
              style="background-color: #fcdede"
            >
              删除
            </h4> -->
            <h4 @click="editInfo(index, item)">信息维护</h4>
          </div>
        </div>
      </div>
      <div v-else class="noprogram">
        <h4>还未拥有项目</h4>
      </div>
      <div class="tspage" v-if="paginations.total > paginations.page_size">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page.sync="paginations.page_index"
          :page-size="paginations.page_size"
          :total="paginations.total"
          layout="prev, pager, next"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import Bus from "@/utils/bus.js";
import { BASE_URL, moneyFormat } from "@/utils/base.js";
import { getProgramList, delProgram, changeStatus } from "@/api/user.js";
export default {
  name: "Home",
  data() {
    return {
      nav: [
        { name: "全部", status: -1 },
        { name: "编辑中", status: 0 },
        { name: "审核中", status: 1 },
        { name: "募集期", status: 2 },
        { name: "运营期", status: 3 },
        { name: "结束", status: 4 },
      ],
      selStatus: [
        { name: "募集期", status: 2 },
        { name: "运营期", status: 3 },
        { name: "结束", status: 4 },
        { name: "前台隐藏", status: 6 },
      ],
      currentIndex: 0,
      keyword: "",
      btnTitle: "",
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 2, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      status:"",
      programData: [],
    };
  },
  mounted() {
    this.$nextTick(function () {
      Bus.$emit("getCmsCurrent", "/myProgram");
    });
    this.getProgram();
  },
  methods: {
    // 项目编辑
    editProgram(item) {
      if (item.status == 1) {
        this.$message.warning("当前项目正在审核中");
      } else {
        this.$router.push({ name: "editMyProgram", params: { pid: item.id } });
      }
    },
    // 修改状态
    async selectChange(e,item) {
      let userInfo = new FormData();
      userInfo.append("id", item.id);
      userInfo.append("status", e);
      let res = await changeStatus(userInfo);
      if (res.code == "OK") {
        this.$message.success(res.msg)
        this.getProgram();
        this.status = ""
      }
    },
    // 信息维护
    editInfo(index, item) {
      if (item.status == 0 || item.status == 1 || item.status == 5) {
        this.$message.warning("当前项目还未通过审核");
      } else {
        this.$router.push({ name: "xxwh", params: { pid: item.id } });
      }
    },
    changeNav(item, index) {
      this.currentIndex = index;
      this.paginations={
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 2, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },
      this.getProgram();
    },                                                    
    //删除
    handleDelete(index, item) {
      if (item.status == 0) {
        this.$confirm("此操作将永久删除该项目, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            let userInfo = new FormData();
            userInfo.append("id", item.id);
            let resData = await delProgram(userInfo);
            if (resData.code == "OK") {
              this.$message({
                type: "success",
                message: "删除成功",
              }),
                this.getProgram();
            } else {
              this.$message({
                type: "warning",
                message: resData.msg,
              });
            }
          })
          .catch(() => {});
      } else {
        this.$message.warning("只有编辑中状态的项目可进行删除操作");
      }
    },
    // 获取项目列表
    async getProgram() {
      let programInfo = new FormData();
      programInfo.append("page", this.paginations.page_index);
      programInfo.append("rows", this.paginations.page_size);
      programInfo.append("dentity", this.$store.state.user.userInfo.id);
      if (this.keyword) {
        programInfo.append("name", this.keyword);
      }
      if (this.currentIndex != 0) {
        programInfo.append("keyword", this.nav[this.currentIndex].status);
      }
      let reg = await getProgramList(programInfo);
      this.keyword = "";
      this.paginations.total = reg.total;
      this.programData = reg.rows;
      this.programData.map((item, index) => {
        item.syMoney = moneyFormat(item.raisefund - item.recipients, 2);
        item.picture = BASE_URL + item.picture;
        item.raisefund = moneyFormat(item.raisefund, 2);
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.paginations.page_index = val;
      this.getProgram();
    },
    // 搜索
    search() {
      if (this.keyword) {
        this.paginations = {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size:5, // 1页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      }
        this.getProgram();
      } else {
        this.$message.warning("搜索内容不能为空");
      }
    },
  },
  components: {},
};
</script>

<style lang="less" scoped>
.home {
  width: 100%;
  padding: 10px 0 40px;
  margin-bottom: 60px;
  .userInfo {
    margin: 0 50px;
    min-height: calc(100vh - 200px);
    .header {
      width: 100%;
      .pHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h3 {
          margin: 20px 0;
          font-size: 18px;
          font-weight: 600;
          color: #333333;
        }
        h2 {
          width: 100px;
          height: 26px;
          line-height: 26px;
          color: #fff;
          font-size: 12px;
          border-radius: 5px;
          text-align: center;
          background-color: #0687c8;
          cursor: pointer;
        }
      }

      .line {
        width: 100%;
        background-color: #dbdbdb;
        height: 1px;
      }
    }
    .pNav {
      margin: 20px 0;
      display: flex;
      justify-content: space-between;
      .pNavLeft {
        ul {
          width: 360px;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          display: flex;
          overflow: hidden;
          li {
            width: 60px;
            height: 24px;
            font-size: 12px;
            line-height: 24px;
            border-left: 1px solid #ebebeb;
            color: #4d4d4d;
            text-align: center;
            cursor: pointer;
          }
          .selected {
            background-color: #0687c8;
            color: #fff;
          }
        }
      }
    }
    .program {
      width: 100%;
      border: 1px solid #ccc;
      border-radius: 5px;
      margin-bottom: 20px;
      .pTop {
        display: flex;
        padding: 20px 0;
        .pTopLeft {
          width: 140px;
          height: 180px;
          margin: 0 20px 0 20px;
          img {
            margin-top: 40px;
            width: 100%;
            height: 90px;
          }
        }
        .pTopRight {
          .pShow {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            display: flex;
            p {
              width: 150px;
              color: 4d4d4d;
            }
            h1 {
              width: 140px;
            }
            h3 {
              width: 250px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
            }
            .pMore {
              flex: 1;
              display: flex;
              justify-content: space-between;
              h2 {
                color: #0687c8;
              }
              h3 {
                width: 250px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                -o-text-overflow: ellipsis;
              }
              h4 {
                width: 120px;
                height: 24px;
                line-height: 24px;
                border: 1px solid #ccc;
                font-size: 12px;
                border-radius: 5px;
                text-align: center;
                background-color: #def2fc;
                cursor: pointer;
              }
            }
          }
        }
      }
      .pFooter {
        display: flex;
        justify-content: space-around;
        margin-bottom: 20px;
        h4 {
          width: 120px;
          height: 24px;
          line-height: 24px;
          border: 1px solid #ccc;
          font-size: 12px;
          border-radius: 5px;
          color: #333;
          text-align: center;
          background-color: #def2fc;
          cursor: pointer;
        }
      }
    }
    .noprogram {
      margin: 30px auto;
      h4 {
        font-size: 16px;
        text-align: center;
        color: #333;
      }
    }
    .tspage {
      margin: 30px 0 30px;
      text-align: center;
      /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #0687c8;
        border: none;
      }
      /deep/ .el-pagination.is-background .el-pager li:not(.disabled) {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
      /deep/ .el-pagination.is-background button {
        background-color: #fff; // 进行修改未选中背景和字体
        border: 1px solid #ededed;
        // color: #fff;
      }
    }
  }
}
</style>
